import React from 'react';
const Checkbox = (props) => {
    const { label, checked, onClick } = props;
    return (React.createElement("div", { className: "checkBox", onClick: onClick },
        React.createElement("div", { className: "box" }, checked && React.createElement("div", { className: "checked" })),
        React.createElement("div", { className: "label" }, label)));
};
export default Checkbox;
